export default __webpack_public_path__ + "static/media/lemonade-promo.ac55a046.png";